import { useCallback, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import {
    getAppFeatures,
    getIsFirstLoginSelector,
    getPasswordMinLengthSelector,
    makeSelectAppFormError,
    makeSelectAppLoggedIn,
    makeSelectAppLoggedInProcess,
} from '../../../app/appSelectors.js';
import { connect } from 'react-redux';
import { registrationPrepareAction } from '../loginActions.js';
import { RouterPaths, URL_SEARCH_PARAMS } from '../../../app/appConstants';
import axios from 'axios';
import { openModalAction, resetFormErrorAction } from '../../../app/appActions.js';
import { usePasswordTooltip } from '../../../components/PasswordTooltip/passwordTooltipHooks';
import { isClientMobile } from '../../../components/ClientInfo/ClientInfo';
import { REGISTRATION_FIELDS_ERRORS } from './registrationConstants';
import { useAbTestOption } from '../../AbTests/abTestsHooks';
import { AB_TESTS_NAMES } from '../../AbTests/abTestsConstants';
import { useInitialUrlSearchParams } from '../../../hooks/useInitialUrlSearchParams';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext.js';
import { useFormFieldErrors } from '../../../hooks/useFormFieldErrors';
import appHistory from '../../../app/appHistory';

export const REGISTRATION_URL_INITIAL_PARAMS = [
    URL_SEARCH_PARAMS.EMAIL,
    URL_SEARCH_PARAMS.PHONE,
];

function Registration(props) {
    const { getLangPath } = useLangContext();
    const {
        features,
        formError,
        isFirstLogin,
        loggedIn,
        loggedInProcess,
        passwordMinLength,
        resetFormError,
        registrationPrepare,
    } = props;

    const { email: initialEmail, phone: initialPhone } = useInitialUrlSearchParams(REGISTRATION_URL_INITIAL_PARAMS);
    const [selectedIso, setSelectedIso] = useState(null);
    const { acceptPolicy: acceptPolicyError, email: emailError, password: passwordError, common: commonError } =
        useFormFieldErrors(REGISTRATION_FIELDS_ERRORS, formError);

    const {
        isShowPasswordTooltip, checkPasswordValue, onBlurPasswordField, onSelectPasswordField, onChangePasswordField,
    } = usePasswordTooltip();

    const registerFieldPhoneOption = useAbTestOption(AB_TESTS_NAMES.REGISTER_FIELD_PHONE);

    useEffect(() => {
        axios.get('https://api.country.is/')
            .then(geo => {
                setSelectedIso(geo.data?.country);
            })
            .catch(() => {
                // nothing
            });
    }, []);

    const submitHandler = useCallback((e) => {
        e.preventDefault();
        registrationPrepare({
            acceptRules: e.target.querySelector('[name=accept-rules]').checked,
            email: e.target.querySelector('[name=email]').value,
            phone: e.target.querySelector('[name=phone]')?.value,
            country: selectedIso?.toLowerCase() || null,
            password: e.target.querySelector('[name=password]')?.value,
        });
    }, [selectedIso, registrationPrepare]);

    const handleChange = useCallback((isValid) => {
        if (!isValid) {
            resetFormError();
        }
    }, [resetFormError]);

    const handlePasswordChange = useCallback((e) => {
        handleChange(!passwordError);
        onChangePasswordField(e);
    }, [handleChange, onChangePasswordField, passwordError]);

    const handleLoginClick = useCallback(() => {
        const email = document.querySelector('[name=email]').value;
        appHistory.push(`${RouterPaths.login}?email=${email}`);
    }, []);

    if (loggedIn) {
        if (isClientMobile && isFirstLogin) {
            return <Redirect to={RouterPaths.mobileDepositBonus} />;
        } else {
            return <Redirect to={RouterPaths.trade} />;
        }
    }

    return <Redirect to={RouterPaths.login} />;

    // return <LoginWrapper hideAuthButton>
    //     <LoginStyled>
    //         <LoginBoxStyled>
    //             <Form.Group className="mb-sm-5 mb-4">
    //                 <h1 className="text-center">{getLangPath('sign_up.title')}</h1>
    //             </Form.Group>
    //             <Form onSubmit={submitHandler}>
    //                 {
    //                     registerFieldPhoneOption !== AB_TEST_REGISTER_FIELD_PHONE_OPTIONS.HIDE &&
    //                     <Form.Group className="mb-4">
    //                         <Form.Control defaultValue={initialPhone || ''} name="phone" type="text"
    //                                       placeholder={getLangPath('sign_up.enter_phone_number')} />
    //                     </Form.Group>
    //                 }
    //
    //                 <Form.Group className="mb-4">
    //                     <Form.Control defaultValue={initialEmail} name="email" type="email"
    //                                   placeholder={getLangPath('sign_up.enter_email')}
    //                                   isInvalid={!!emailError} onChange={() => handleChange(!emailError)}
    //                     />
    //                     {
    //                         !!emailError && <>
    //                             <Form.Control.Feedback type="invalid">
    //                                 {getLangPath(emailError)}
    //                                 {emailError === 'error.already_registered' && (
    //                                     <>.&nbsp;<u onClick={handleLoginClick}>{getLangPath('promo.fx.log_in')}</u></>
    //                                 )}
    //                             </Form.Control.Feedback>
    //                         </>
    //                     }
    //                 </Form.Group>
    //
    //                 {
    //                     !!features.register_without_verify && (
    //                         <PasswordTooltip password={checkPasswordValue} show={isShowPasswordTooltip}>
    //                             <Form.Group>
    //                                 <FormPasswordEye
    //                                     name="password"
    //                                     placeholder={getLangPath('sign_up.create_password')}
    //                                     isInvalid={!!passwordError}
    //                                     onSelect={onSelectPasswordField}
    //                                     onBlur={onBlurPasswordField}
    //                                     onChange={handlePasswordChange}
    //                                 />
    //                                 {
    //                                     !!passwordError && (
    //                                         <Form.Control.Feedback type="invalid">
    //                                             {getLangPath(passwordError, { count: passwordMinLength })}
    //                                         </Form.Control.Feedback>
    //                                     )
    //                                 }
    //                             </Form.Group>
    //                         </PasswordTooltip>
    //                     )
    //                 }
    //                 {
    //                     !!commonError && (
    //                         <Form.Control.Feedback type="invalid" className="d-block mt-3">
    //                             {getLangPath(commonError)}
    //                         </Form.Control.Feedback>
    //                     )
    //                 }
    //
    //                 <RegistrationAcceptPolicy className="mb-4 mt-4" error={acceptPolicyError}
    //                                           onChange={() => handleChange(!acceptPolicyError)} />
    //
    //                 <div className="d-grid">
    //                     <Button variant={'primary'} size={'lg'} type="submit" className={'mb-4'}>
    //                         {getLangPath('sign_up.title')}
    //                     </Button>
    //                     <Button variant={'outline-info'} size={'md'} onClick={handleLoginClick} type="button">
    //                         {getLangPath('sign_up.have_account')}
    //                     </Button>
    //                 </div>
    //             </Form>
    //             <Loader show={loggedInProcess} />
    //         </LoginBoxStyled>
    //     </LoginStyled>
    // </LoginWrapper>;
}

const mapStateToProps = createStructuredSelector({
    isFirstLogin: getIsFirstLoginSelector,
    features: getAppFeatures,
    loggedIn: makeSelectAppLoggedIn(),
    loggedInProcess: makeSelectAppLoggedInProcess(),
    formError: makeSelectAppFormError(),
    passwordMinLength: getPasswordMinLengthSelector,
});

const mapDispatchToProps = (dispatch) => ({
    openModal: (payload) => dispatch(openModalAction(payload)),
    registrationPrepare: (payload) => dispatch(registrationPrepareAction(payload)),
    resetFormError: (payload) => dispatch(resetFormErrorAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Registration);
